export default {
    methods: {
        calcHeight() {
            setTimeout(() => {
                let totalHeight = 0;
                let heightStr = document.querySelectorAll(".infoBox");
                let heightString = Array.prototype.slice.call(heightStr);
                let selfItemHeight = document.querySelector(".infoBoxHate");

                heightString.forEach(function (item) {
                    let style = window.getComputedStyle(item);
                    let marginTop = style.getPropertyValue('margin-top');
                    let marginBottom = style.getPropertyValue('margin-bottom');
                    totalHeight += item.offsetHeight;
                    totalHeight += parseInt(marginTop);
                    totalHeight += parseInt(marginBottom);
                });

                let teacherTabPaddingStyle, teacherTabPaddingTop, selfMainContainer, mainContainer, minMainContainer;
                let contentHeight = totalHeight;
                let teacherTabPadding = this.$el.querySelector(".teacher-tab");
                if (teacherTabPadding) {
                    teacherTabPaddingStyle = window.getComputedStyle(teacherTabPadding);
                    teacherTabPaddingTop = teacherTabPaddingStyle.getPropertyValue('padding-top');
                }

                mainContainer = this.$el.querySelectorAll(".calcHeight");
                minMainContainer = this.$el.querySelector(".calcHeightMin");
                selfMainContainer = this.$el.querySelectorAll(".calcHeightSelf");

                if (mainContainer) {
                    mainContainer.forEach(function (item) {
                        item.style.maxHeight = `calc(100vh - ${contentHeight + 20 + (teacherTabPaddingTop ? parseInt(teacherTabPaddingTop) + 30 : 0)}px)`
                    });

                    if (minMainContainer) {
                        mainContainer.forEach(function (item) {
                            item.style.minHeight = `calc(100vh - ${contentHeight + 20 + (teacherTabPaddingTop ? parseInt(teacherTabPaddingTop) + 30 : 0)}px)`
                        })
                    } else {
                        mainContainer.forEach(function (item) {
                            item.style.minHeight = ''
                        })
                    }
                }

                if (selfMainContainer) {
                    let selfContainer = selfItemHeight ? selfItemHeight.offsetHeight : 0;
                    selfMainContainer.forEach(function (item) {
                        item.style.maxHeight = `calc(100vh - ${contentHeight + 20 + (teacherTabPaddingTop ? parseInt(teacherTabPaddingTop) + 30 : 0) - selfContainer}px)`
                    })
                }
            }, 0)
        },
    }
};